import script from "./printInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./printInvoice.vue?vue&type=script&setup=true&lang=js"

import "./printInvoice.vue?vue&type=style&index=0&id=54b34280&lang=less"

const __exports__ = script;

export default __exports__